import _asyncToGenerator from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createClass from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/root/code/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import axios from "axios";
export var ServerGQLClientError = /*#__PURE__*/_createClass(function ServerGQLClientError() {
  _classCallCheck(this, ServerGQLClientError);

  _defineProperty(this, "errors", void 0);

  _defineProperty(this, "data", void 0);
});
export var ServerGQLClient = /*#__PURE__*/function () {
  function ServerGQLClient(_ref) {
    var uri = _ref.uri;

    _classCallCheck(this, ServerGQLClient);

    _defineProperty(this, "uri", void 0);

    this.uri = uri;
  }

  _createClass(ServerGQLClient, [{
    key: "query",
    value: function () {
      var _query2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var _query, variables, headers, response;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _query = _ref2.query, variables = _ref2.variables, headers = _ref2.headers;
                _context.prev = 1;
                _context.next = 4;
                return axios.post(this.uri, {
                  query: _query,
                  variables: variables
                }, {
                  headers: headers
                });

              case 4:
                response = _context.sent;
                return _context.abrupt("return", response.data);

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                return _context.abrupt("return", _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8]]);
      }));

      function query(_x) {
        return _query2.apply(this, arguments);
      }

      return query;
    }()
  }]);

  return ServerGQLClient;
}();